module.exports = __webpack_public_path__ + "img/two_rows.377b75c5.svg";